import { render } from "./AnaesthesiaRecord.vue?vue&type=template&id=2eb525b7&scoped=true"
import script from "./AnaesthesiaRecord.vue?vue&type=script&lang=js"
export * from "./AnaesthesiaRecord.vue?vue&type=script&lang=js"

import "./AnaesthesiaRecord.vue?vue&type=style&index=0&id=2eb525b7&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eb525b7"]])

export default __exports__